import { RequestStatus } from "../../request";
import { AccountInfo } from "./reducer";

export const SignInAction = (mail: string, password: string) => {
  return {
    type: "authentication-update-sign-in",
    mail: mail,
    password: password,
  };
};

export const UpdateSignInRequestState = (requestState: RequestStatus) => {
  return {
    type: "authentication-update-sign-in-request-state",
    requestState: requestState,
  };
};

export const UpdateAccountInfoAction = (accountInfo: AccountInfo) => {
  return {
    type: "authentication-update-account-info",
    accountInfo: accountInfo,
  };
};
